/**
 * Custom hook for accessing current language provided to TranslationsProvider.
 *
 * @returns Language which contains translations and related information.
 */
import { useContext, useMemo } from 'react';
import { translationsContext } from '../translationsContext';
export const useLanguage = () => {
  const {
    currentLanguage,
    language
  } = useContext(translationsContext);
  return useMemo(() => ({
    language: language ?? currentLanguage ?? ''
  }), [language, currentLanguage]);
};
//# sourceMappingURL=useLanguage.js.map